import React from "react";
import CareerIntro from "../components/Career/CareerIntro";
import OpenPosition from "../components/Career/OpenPosition";
import CareerForm from "../components/Career/CareerForm";
import Banner from "../components/Banner";

const Career = () => {
  const scrollToApplyForm = () => {
    const applyFormSection = document.getElementById("formsFill");
    if (applyFormSection) {
      applyFormSection.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <>
      <CareerIntro scrollToApplyForm={scrollToApplyForm} />
      <OpenPosition scrollToApplyForm={scrollToApplyForm} />
      <div id="formsFill">
        <CareerForm />
      </div>
      <Banner />
    </>
  );
};

export default Career;
